module.exports = __webpack_public_path__ + "static/emergency-121f067bf06b404a827e3a8bc5d09376.png";